export default "__VITE_ASSET__vLkk1GKJ__"